import styled from 'styled-components';

export const Wrapper = styled.div`
  min-height: 150px;
`;




// WEBPACK FOOTER //
// ./src/modals/organization-settings-modal/styled-components.js